import { consoleLog } from '@Utils/consoleLog';

import type {
  ConfirmUserOrderResponse,
  ReconfirmUserOrderResponse,
} from './ownable.dtos';
import {
  AuthenticateUserOrder,
  ConfirmUserOrder,
  ReconfirmUserOrder,
} from './ownable.dtos';
import ServiceStackGateway from './service-stack';

type AuthenticateUserOrderRequestInput = {
  orderId: number;
  saveAddress: boolean;
  saveAddressAs: string;
  saveCard: boolean;
  saveCardAs: string;
  setAddressAsDefault: boolean;
  setCardAsDefault: boolean;
};

export function prepareAuthenticateUserOrderRequest({
  orderId,
  saveAddress,
  saveAddressAs,
  saveCard,
  saveCardAs,
  setAddressAsDefault,
  setCardAsDefault,
}: AuthenticateUserOrderRequestInput) {
  const request = new AuthenticateUserOrder();
  request.orderId = orderId;
  request.saveAddress = saveAddress;
  request.saveAddressAs = saveAddressAs;
  request.saveCard = saveCard;
  request.saveCardAs = saveCardAs;
  request.setAddressAsDefault = setAddressAsDefault;
  request.setCardAsDefault = setCardAsDefault;
  return request;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class CheckoutAPI {
  public static async confirmUserOrder({
    anonymousUserEmail,
    anonymousUserName,
    deliveryDetails,
    paymentDetails,
    productId,
    productOptionId,
    quantity = 1,
  }: Omit<
    ConfirmUserOrder,
    'createResponse' | 'getTypeName'
  >): Promise<ConfirmUserOrderResponse | null> {
    try {
      const request = new ConfirmUserOrder();
      request.deliveryDetails = deliveryDetails;
      request.paymentDetails = paymentDetails;
      request.productId = productId;
      request.productOptionId = productOptionId;
      request.quantity = quantity;
      request.anonymousUserEmail = anonymousUserEmail ?? null;
      request.anonymousUserName = anonymousUserName ?? null;

      return await ServiceStackGateway.post<ConfirmUserOrderResponse>(request);
    } catch (err) {
      consoleLog({ err });
      return null;
    }
  }

  public static reconfirmUserOrder({
    orderId,
    quantity,
    paymentDetails,
    deliveryDetails,
    anonymousUserEmail,
    anonymousUserName,
    productOptionId,
  }: Pick<
    ReconfirmUserOrder,
    | 'anonymousUserEmail'
    | 'anonymousUserName'
    | 'deliveryDetails'
    | 'orderId'
    | 'paymentDetails'
    | 'productOptionId'
    | 'quantity'
  >): Promise<ReconfirmUserOrderResponse> {
    const request = new ReconfirmUserOrder();
    request.orderId = orderId;
    request.quantity = quantity;
    request.paymentDetails = paymentDetails;
    request.deliveryDetails = deliveryDetails;
    request.anonymousUserEmail = anonymousUserEmail ?? undefined;
    request.anonymousUserName = anonymousUserName ?? undefined;
    request.productOptionId = productOptionId ?? undefined;

    return ServiceStackGateway.post<ReconfirmUserOrderResponse>(request);
  }
}

export default CheckoutAPI;
